import { createContext } from 'react';
import { Swiper as SwiperClass } from 'swiper/types';

import { ReplicaPageWithArticleId } from '../replica.hooks';

export const SingleViewContext = createContext<SingleViewContextProps>({
	index: 0,
	prefersReducedMotion: false,
	pages: [],
	setSwiper: () => {},
	setIndex: () => {},
	onNextArticleClick: () => {},
	onPrevArticleClick: () => {},
	toggleMenu: () => {},
	isProfileMenuOpen: false,
	setIsProfileMenuOpen: () => {},
	openLightbox: () => {},
});

interface SingleViewContextProps {
	swiper?: SwiperClass;
	setSwiper: (s: SwiperClass) => void;
	index: number;
	prefersReducedMotion: boolean;
	setIndex: (i: number) => void;
	pages: Array<ReplicaPageWithArticleId>;
	onNextArticleClick: () => void;
	onPrevArticleClick: () => void;
	toggleMenu: () => void;
	isProfileMenuOpen: boolean;
	setIsProfileMenuOpen: (v: boolean) => void;
	/** Opens the page at this index in the lightbox. */
	openLightbox: (pageIndex: number) => void;
}
